import { useAuth } from "./AuthContext";

/**
 * Custom hook to check user subscription status and feature access
 */
export const useSubscription = () => {
  const { userProfile } = useAuth();
  
  // Check if user has a paid subscription
  const isPaidUser = userProfile?.subscription && 
    userProfile.subscription !== "free";
  
  // Check if user is on free plan
  const isFreeUser = !isPaidUser;
  
  // Get current subscription plan
  const currentPlan = userProfile?.subscription || "free";
  
  // Check if specific features are enabled based on subscription
  // All editing/creation features require paid subscription
  const canEditFields = isPaidUser;
  const canCreateTenders = isPaidUser;
  const canUseAIFeatures = isPaidUser;
  const canUseProposalWriter = isPaidUser;
  const canUseComplianceTracking = isPaidUser;
  
  return {
    isPaidUser,
    isFreeUser,
    currentPlan,
    canEditFields,
    canCreateTenders,
    canUseAIFeatures,
    canUseProposalWriter,
    canUseComplianceTracking,
  };
};
